import { Component } from 'react'
import PropTypes from 'prop-types'
import { reduxForm } from 'redux-form'
import { Form } from 'components/forms'
import MailcheckedInput from 'components/mailchecked-input'
import { InfoButton } from 'components/buttons'
import { createValidator, email, required } from 'lib/form-validation'
import DateSelect from 'components/date-select'

const validator = createValidator({
  email: [required, email],
})

export class FirstStepSignupForm extends Component {
  static propTypes = {
    error: PropTypes.object,
    fields: PropTypes.shape({
      email: PropTypes.object.isRequired,
    }),
    signedUp: PropTypes.bool,
    submitting: PropTypes.bool,
  }

  static defaultProps = {
    signedUp: false,
  }

  componentDidUpdate(prevProps) {
    // There is render bug which is reseting the values set by initialValues in redux-form.
    // This is a patch to re-initialize the form with the correct initialValues.
    // TODO: Refactor this so we're not using redux-form.
    if (
      this.props.fields.email.value !== prevProps.fields.email.value &&
      !this.props.fields.email.dirty
    ) {
      if (
        prevProps.fields.email.value &&
        prevProps.fields.email.value !== '' &&
        this.props.fields.email.value === ''
      ) {
        this.props.initializeForm({ email: prevProps.fields.email.value })
      }
    }
  }

  render() {
    const {
      children,
      signedUp,
      error,
      submitting,
      fields: { email, arrivalDate },
    } = this.props

    const submitButtonText = 'Get Started'
    return (
      <Form error={error} onSubmit={this.props.handleSubmit}>
        <MailcheckedInput
          {...email}
          mailcheckOnChange
          disabled={signedUp}
          error={email.touched ? email.error : null}
          id="email-field"
          label="Email address"
          mailcheckDelay={300}
          mailcheckOnBlur={false}
          name="email"
          type="text"
        />

        <DateSelect
          {...arrivalDate}
          error={arrivalDate.touched ? arrivalDate.error : null}
          groupClassName="mbm"
          label="Arrival Date (Optional)"
          name="arrivalDate"
        />
        {!signedUp && (
          <>
            <>
              {children}
              <div className="btn-group btn-group--stretch">
                <InfoButton
                  // DO NOT REMOVE: Allows 3rd party tracking pixels to identify when this button is clicked
                  block
                  pill
                  className="mbl"
                  data-external-tracking-identifier="signup"
                  disabled={signedUp || submitting}
                  submitting={submitting}
                  type="submit"
                >
                  {submitButtonText}
                </InfoButton>
              </div>
            </>
          </>
        )}
      </Form>
    )
  }
}

export const mapStateToProps = (state, ownProps) => ({
  // Shimmed hack into redux-form
  // This is necessary because we need to format name data right before submitting.
  // ReduxForm automatically will call onSubmit in this.props.handleSubmit
  onSubmit: ({ email }) => ownProps.onSubmit(email),
})

export default reduxForm(
  {
    form: 'OneStepSignupForm',
    fields: ['email', 'arrivalDate'],
    validate: validator,
  },
  mapStateToProps
)(FirstStepSignupForm)
